export default [
  {
    path: 'attract-invest-banner',
    name: 'attractInvestBanner',
    meta: {
      isDynamic: true,
      id: '轮播图管理',
      inTab: true
    },
    component: () => import('@/views/AttractInvest/AttractInvestBanner/AttractInvestBanner.vue')
  },
  {
    path: 'attract-invest-apply',
    name: 'AttractInvestApply',
    meta: {
      isDynamic: true,
      id: '招商申请',
      inTab: true
    },
    component: () => import('@/views/AttractInvest/AttractInvestApply/AttractInvestApply.vue')
  },
  {
    path: 'attract-invest-product',
    name: 'AttractInvestProduct',
    meta: {
      isDynamic: true,
      id: '招商品种管理',
      inTab: true
    },
    component: () => import('@/views/AttractInvest/AttractInvestProduct/AttractInvestProduct.vue')
  },
  {
    path: 'save-attract-invest-product',
    name: 'SaveAttractInvestProduct',
    meta: {
      id: '新增招商品种'
    },
    component: () =>
      import('@/views/AttractInvest/SaveAttractInvestProduct/SaveAttractInvestProduct.vue')
  }
];
